import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { DialogGalleryComponent } from "../dialog-gallery/dialog-gallery.component";
export interface CardContent {
  card_id: number;
  card_id_1: number;
  card_name: string;
  card_id_2: number | null;
  card_name_2: string | null;
  card_value_1: string | null;
  card_date: string | null;
  card_value_2: string | null;
  card_user_id: number | null;
  card_username: string | null;
  card_user_image_url: string | null;
  card_image_url: string | null;
}

// export interface DialogData {
//   formAnyDate: boolean;
//   formDate: any | null;
//   formDateInit: any | null;
//   formDateEnd: any | null;
//   formSelected: string | null;
//   formPersonId: number | null;
//   formPersonValue: string | null;
//   formSite: string | null;
// }

@Component({
  selector: "app-template-row",
  templateUrl: "./template-row.component.html",
  styleUrls: ["./template-row.component.css"],
})
export class TemplateRowComponent implements OnInit {
  constructor(private router: Router, public dialog: MatDialog) { }
  @Input() cardContent!: CardContent;
  @Input() route!: string;
  @Input() design!: string;

  // dialogData: DialogData = {
  //   formAnyDate: true,
  //   formDate: null,
  //   formDateInit: null,
  //   formDateEnd: null,
  //   formSelected: null,
  //   formPersonId: null,
  //   formPersonValue: null,
  //   formSite: null,
  // };

  ngOnInit(): void { }

  time_ago(time: any) {
    switch (typeof time) {
      case "number":
        break;
      case "string":
        time = +new Date(time);
        break;
      case "object":
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, "segundos", 1], // 60
      [120, "1 minuto atrás", "1 minuto desde ahora"], // 60*2
      [3600, "minutos", 60], // 60*60, 60
      [7200, "1 hora atrás", "1 hora desde ahora"], // 60*60*2
      [86400, "horas", 3600], // 60*60*24, 60*60
      [172800, "Ayer", "Mañana"], // 60*60*24*2
      [604800, "días", 86400], // 60*60*24*7, 60*60*24
      [1209600, "Última semana", "Siguiente semana"], // 60*60*24*7*4*2
      [2419200, "semanas", 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, "Último mes", "Siguiente mes"], // 60*60*24*7*4*2
      [29030400, "meses", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, "Último año", "Siguiente año"], // 60*60*24*7*4*12*2
      [2903040000, "años", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, "Último siglo", "Siguiente siglo"], // 60*60*24*7*4*12*100*2
      [58060800000, "siglos", 2903040000], // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
    var seconds = (+new Date() - time) / 1000,
      token = "atrás",
      list_choice = 1;

    if (seconds == 0) {
      return "Justo ahora";
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      token = "desde ahora";
      list_choice = 2;
    }
    var i = 0,
      format;
    while ((format = time_formats[i++]))
      if (typeof format[0] == "number") {
        if (seconds < format[0]) {
          if (typeof format[2] == "string") return format[list_choice];
          else
            return (
              Math.floor(seconds / format[2]) + " " + format[1] + " " + token
            );
        }
      }

    return time;
  }

  fnItem(id: number | string) {
    const _router = "/" + this.route;
    // this.router.navigate([_router, id]);

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([_router, id]).then(() => {
      })
    })

  }

  fnOpenDialog(bt: any, _width: number, _id: number): void {
    const _element = bt._elementRef.nativeElement;
    const _rect = _element
      ? _element.getBoundingClientRect()
      : { top: 0, left: 0 };

    const _dialogRef = this.dialog.open(DialogGalleryComponent, {
      width: _width + "px",
      data: _id,
      position: {
        top: _rect.bottom + "px",
        left: _rect.right - _width + "px",
      },
    });

    // _dialogRef.afterClosed().subscribe((_result: DialogData) => {
    //   if (_result) {
    //     // this.dialogData = _result;

    //     // let _badgeFilters = 0;
    //     // _badgeFilters = _badgeFilters + (_result.formDate ? 1 : 0);
    //     // _badgeFilters = _badgeFilters + (_result.formDateInit ? 1 : 0);
    //     // _badgeFilters = _badgeFilters + (_result.formDateEnd ? 1 : 0);
    //     // _badgeFilters = _badgeFilters + (_result.formSelected ? 1 : 0);
    //     // _badgeFilters = _badgeFilters + (_result.formPersonId ? 1 : 0);
    //     // _badgeFilters = _badgeFilters + (_result.formSite ? 1 : 0);

    //     // this.badgeFilter = _badgeFilters;

    //     // this.observation_date_control.setValue(
    //     //   _result.formDate
    //     //     ? _result.formDate.toISOString().slice(0, 10).replace("T", " ")
    //     //     : null
    //     // );

    //     // this.observation_date_start_control.setValue(
    //     //   _result.formDateInit
    //     //     ? _result.formDateInit.toISOString().slice(0, 10).replace("T", " ")
    //     //     : null
    //     // );
    //     // this.observation_date_end_control.setValue(
    //     //   _result.formDateEnd
    //     //     ? _result.formDateEnd.toISOString().slice(0, 10).replace("T", " ")
    //     //     : null
    //     // );

    //     // this.user_id_control.setValue(
    //     //   _result.formPersonId ? _result.formPersonId : null
    //     // );

    //     // this.fnSearchVarietyObservation();
    //   }
    // });
  }
}
